import firebase from 'firebase'
import db from '@/firebase/init'

const state = {
    locations: [

    ],
    location: null
};

const getters = {
    allLocations: (state) => state.locations,
    selectedLocation: (state) => state.location
}

const actions = {
    async getAllLocations({ commit }) {
        var locations = [];
        //Get data from the firestore
        var collection = db.collection('locations')
        const response = await collection.get();
        response.forEach(doc => {
            let location = doc.data()
            location.id = doc.id
            if(location.active){
                locations.push(location);
            }
        });
        locations.sort((a,b) => (a.locationid > b.locationid) ? 1 : ((b.locationid > a.locationid) ? -1 : 0)); 

        commit('setLocations', locations)
    },
    async setLocation({ commit }, locationid) {

        var location = null;
        
        console.log("Setting locationid" + locationid)	
        console.log(locationid)

        //Get data from the firestore
        var doc = await db.collection('locations').doc(locationid).get()
        location = doc.data();
        location.id = locationid
        commit('setLocation', location)
    },
    async updateLocation({ commit }, location) {
        console.log(location);
        db.collection("locations").doc(location.id).update({ locatie: location.locatie, naam: location.naam, plekken: location.plekken, locationid: location.locationid, limiet: location.limiet }).then(()=>{
            console.log("Location updated")
        }).catch((err) => {
            console.log(err)
        })
        //Get data from the firestore
        // commit('setLocation', location)
    }
}

const mutations = {
    setLocations: (state, locations) => (state.locations = locations),
    setLocation: (state, location) => (state.location = location)
}

export default {
    state,
    getters,
    actions, 
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/locations.js